// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountMenu-cls1__f8406f94d2d6d7b017e4{/*!*/}.AccountMenu-cls2___18cf4f8b7aecfe11e28{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AccountMenu-cls1__f8406f94d2d6d7b017e4",
	"cls2": "AccountMenu-cls2___18cf4f8b7aecfe11e28 AccountMenu-cls1__f8406f94d2d6d7b017e4"
};
export default ___CSS_LOADER_EXPORT___;
